import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { RoutingService } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class RecentSearchService {
  platformId = inject(PLATFORM_ID);
  constructor(protected routingService: RoutingService) { }

  getRecentSearches(storageName): any[] {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem('RecentSearchBox')) {
        localStorage.removeItem('RecentSearchBox');
        localStorage.removeItem('RecentSearchBox1');
      }
      return JSON.parse(localStorage.getItem(storageName)) || [];
    }
    else {
      return [];
    }
  }
  saveRecentSearch(searchValue: string, storageName: string): void {
    let recentSearches = this.getRecentSearches(storageName);
    const isDuplicate = recentSearches.some((item) => item.value === searchValue);

    if (!isDuplicate) {
      recentSearches.unshift({ value: searchValue, url: searchValue });
      recentSearches = recentSearches.slice(0, 5);
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem(storageName, JSON.stringify(recentSearches));
      }
    }
  }
  launchSearchPage(query: string): void {
    this.routingService.go({
      cxRoute: 'search',
      params: { query },
    });
  }
}
